
























// Importing components
import BaseCard from '@/ui/BaseCard.vue';
import TheFormUsers from '@/components/users/TheFormUsers.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
// Importing functions
import {validateCreateUser} from '@/ts/users/validate-user';
import {postUser} from '@/ts/users/post-user';

export default {
    name: 'PageUsersUpdate',
    components: {
        LayoutApp,
        BaseCard,
        TheFormUsers,
    },
    props: {},
    data() {
        return {
            userData: Object(),
            errors: Array(),
            items: Array(),
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateCreateUser(this.errors, this.userData);

            if (this.errors.length === 0) {
                postUser(this.errors, this.userData).then(() => {
                    this.$router.push({ path: '/users' });
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Потребители',
            to: { path: '/users' },
        }, {
            text: 'Създаване',
        }];
        // Initializing the user data object
        this.userData = {
            first_name: '', last_name: '', email: '',
            phone: '', password: '', password_confirmation: '',
            roles: [], permissions: [],
        };
    },
};
